import { createContext } from 'react';

interface AuthContextValues {
  getAuthToken: () => string | undefined;
  getXToken: () => string | undefined;
  authLoaded: boolean;
}

const AuthContext = createContext<AuthContextValues>({
  getAuthToken: () => undefined,
  getXToken: () => undefined,
  authLoaded: false,
});

export default AuthContext;
